import { action, observable, runInAction } from "mobx";
import { api, api_adm, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _MvaStorePA {
  obs = observable({
    mvas: [] as any[],
    currentPage: 1 as number,
    length_mvas: 0 as number,
    filter_vigencia: true as boolean,
    selectedTab: "entrada" as string
  })

  @action
  async handlePageFilter(page: number, filter: string) {
    try {
      let data = {
        page: page,
        limit: 20,
        filter: filter.replace(/\./g, ""),
        vigencia: this.obs.filter_vigencia,
        entrada: this.obs.selectedTab == "entrada" ? true : false
      }

      let resp = await apiOperacao("legislacoes").post("/legislacoes/mvas/index", data);

      this.obs.mvas = [];
      this.obs.length_mvas = 0;

      if (resp.data.itens.length > 0) {
        this.obs.mvas = resp.data.itens
        this.obs.length_mvas = resp.data.count
      }

    } catch (ex) {

      toast_error(ex, `Erro ao filtrar MVAs, tente novamente mais tarde.`);

    }

  }

  async doSaveCreateMva(mva) {
    try {
      let resp = await api_adm.post("/api/admin/mvas", mva);

      if (resp.data.ok) {
        toast.success('MVA criado', {});
        return true

      } else {
        toast.error(`Erro ao criar MVA!`, {});
      }

    } catch (ex) {
      toast.error(`Erro ao criar MVA!`, {});
    }

    return false
  }

  async handleDeleteMva(id) {
    try {
      let resp = await api_adm.delete(`/api/admin/mvas/${id}`);

      if (resp.data.ok) {
        toast.success('MVA excluído', {});
        return true

      } else {
        toast.error(`Erro ao excluir MVA!`, {});
      }

    } catch (ex) {
      toast.error(`Erro ao excluir MVA!`, {});
    }

    return false
  }

  async doSaveEditMva(mva) {
    try {
      let resp = await api_adm.put(`/api/admin/mvas/${mva.id}`, mva);

      if (resp.data.ok) {
        toast.success('MVA Editado', {});
        return true

      } else {
        toast.error(`Erro ao salvar MVA!`, {});
      }

    } catch (ex) {
      toast.error(`Erro ao salvar MVA`, {});
    }

    return false
  }

  async doSaveDuplicaMva(mva) {
    try {
      let resp = await api_adm.post('/api/admin/mvas', mva);

      if (resp.data.ok) {
        toast.success('MVA Duplicado', {});
        return true

      } else {
        toast.error(`Erro ao duplicar MVA!`, {});
      }

    } catch (ex) {
      toast.error(`Erro ao duplicar MVA`, {});
    }

    return false
  }

  async handleExport(estado: string, entrada: boolean) {

    try {
      let resp = await apiOperacao("legislacoes").post("/legislacoes/mvas/excel", {estado: estado, entrada: entrada});

      if (resp.data.ok) {
        const linkSource = `data:application/xlsx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "export_mvas.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {
        toast.warning(resp.data.error, {});
      }

    } catch (ex) {

      toast_error(ex, `Erro ao exportar MVAs, tente novamente mais tarde.`);

    }

  }

  async handleImport(data) {

    let resp = await api_adm.post("/api/admin/mvas/excel/import", data)

    if (resp.data.ok) {

      toast.success('Arquivo importado com sucesso!', {});
      
      return true

    }
        
    toast.error(resp.data.error, {});

    return false
    
  }

}

export const MvaStorePA = new _MvaStorePA();
